import { Editor } from 'tinymce';
import { isAtRangeEnd } from 'controls/designer/features/widgets/textWidget/components/text-widget-editor/utils/isAtRangeEdge';

export function isAtContentEnd(ed: Editor, selectionRng: Range): boolean {
	const contentContainer = ed.contentDocument.getElementById('tinymce');
	return isAtRangeEnd(selectionRng, contentContainer);
}
